export default function ArrayToUiList(inputArray: any) {
  let outputList: any = []

  inputArray.map((input: any) => {
    if(typeof input === 'object'){
      return outputList.push(input)
    }

    return outputList.push({
      key: input,
      text: input,
      value: input
    })
  })

  return outputList
}